/**
 * Each category id contains a list of exact refinements with their corresponding heading titles
 * e.g. for { '29330': { 'type:wedding': 'Mens wedding rings' } }
 * if the lister category is '29330' and the refinements are exactly 'type:wedding', the heading title will be 'Mens wedding rings'
 *  */
const refinedHeadingOverrides = {
  29059: {
    'fixing:pressure-fit': 'Pressure fit Safety gates'
  },
  29184: {
    'type:helium-cylinder': 'Helium cannisters'
  },
  29219: {
    'type:wrist-blood-pressure-monitor': 'Wrist blood pressure monitors'
  },
  29235: {
    'type:diffuser-hairdryers': 'Diffuser hair dryers',
    'type:travel-hairdryers': 'Travel hair dryers'
  },
  29236: {
    'cordless:yes': 'Cordless Hair straighteners'
  },
  29237: {
    'type:automatic-curler': 'Automatic curlers'
  },
  29238: {
    'type:hot-air-stylers-and-brushes': 'Hot air stylers'
  },
  29256: {
    'type:wet-and-dry-use': 'Wet and dry Electric shavers'
  },
  29261: {
    'illuminated:yes': 'Illuminated Makeup mirrors'
  },
  29279: {
    'type:self-propelled-wheelchairs': 'Self propelled Wheelchairs'
  },
  29307: {
    'time-display:digital': "Men's Digital Watches"
  },
  29311: {
    'type:nose-studs': 'Nose studs'
  },
  29312: {
    'type:charm-bracelets': "Women's charm bracelets"
  },
  29315: {
    'type:hoop-earrings': "Women's hoop earrings",
    'type:stud-earrings': "Women's stud earrings"
  },
  29316: {
    'type:lockets': "Women's locket necklaces"
  },
  29317: {
    'type:engagement': "Women's engagement rings",
    'type:wedding': "Women's wedding rings",
    'type:eternity': 'Womens Eternity rings'
  },
  29330: {
    'type:wedding': 'Mens wedding rings'
  },
  29382: {
    'fuel-type:gas': 'Gas barbecues',
    'type:portable': 'Portable Barbecues',
    'fuel-type:charcoal': 'Charcoal barbecues'
  },
  29391: {
    'type:bistro-sets': 'Bistro sets'
  },
  29400: {
    'type:hot-tubs': 'Hot tubs'
  },
  29432: {
    'type:travel-irons': 'Travel irons',
    'type:steam-generators': 'Steam generator irons',
    'type:steam-irons': 'Steam irons',
    'anti-scale:yes': 'Anti-Scale Irons',
    'brands:morphy-richards/type:steam-generators': 'Morphy Richards Steam Generator Irons',
    'brands:philips/type:steam-generators': 'Philips Steam Generator Irons',
    'brands:russell-hobbs/type:steam-generators': 'Russell Hobbs Steam Generator Irons',
    'brands:tefal/type:steam-generators': 'Tefal Steam Generator Irons'
  },
  29433: {
    'type:airer-covers': 'Clothes Airer Covers'
  },
  29436: {
    'type:washing-line-accessories': 'Washing Line Accessories'
  },
  29439: {
    'type:tower-fans': 'Tower fans',
    'type:desk-fan': 'Desk fans',
    'type:pedestal-fans': 'Pedestal fans'
  },
  29440: {
    'type:air-coolers': 'Air coolers'
  },
  29444: {
    'type:oil-filled-radiators': 'Oil filled radiators',
    'type:halogen-heaters': 'Halogen heaters',
    'type:fan-heaters': 'Fan heaters',
    'type:ceramic-heaters': 'Ceramic heaters',
    'type:convector-heaters': 'Convector heaters'
  },
  29454: {
    'type:electric-stove-fires': 'Electric stove fires',
    'type:electirc-fire-suites': 'Electirc fire suites',
    'type:electric-inset-fires': 'Electric inset fires'
  },
  29471: {
    'type:letterboxes-and-plaques': 'Letterboxes'
  },
  29472: {
    'type:heated-throws': 'Heated throws',
    'type:overblankets': 'Heated Overblankets',
    'bed-size:double/type:underblankets': 'Double Electric Underblankets',
    'bed-size:double/fitting:fitted': 'Double Fitted Electric Blankets',
    'brands:dreamland/fitting:fitted': 'Dreamland Fitted Electric Blankets',
    'brands:dreamland/type:mattress-covers-and-protectors': 'Dreamland Heated Mattress Protectors',
    'brands:dreamland/type:overblankets': 'Dreamland Heated Overblankets',
    'brands:dreamland/type:heated-throws': 'Dreamland Heated Throws',
    'type:underblankets': 'Electric Underblankets',
    'bed-size:king-size/type:underblankets': 'King Size Electric Underblankets',
    'bed-size:king-size/fitting:fitted': 'King Size Fitted Electric Blankets',
    'bed-size:single/type:overblankets': 'Single Electric Overblankets',
    'bed-size:single/type:underblankets': 'Single Electric Underblankets'
  },
  29473: {
    'tog-rating:4.5': '4.5 Tog Duvets',
    'tog-rating:10.5': '10.5 Tog Duvets',
    'tog-rating:13.5': '13.5 Tog Duvets',
    'tog-rating:15': '15 Tog Duvets',
    'tog-rating:1': '1 Tog Duvets',
    'bed-size:double/tog-rating:10.5': '10.5 Tog Double Duvets',
    'bed-size:king-size/tog-rating:10.5': '10.5 Tog King Size Duvets',
    'bed-size:single/tog-rating:10.5': '10.5 Tog Single Duvets',
    'bed-size:super-king/tog-rating:10.5': '10.5 Tog Super King Duvets',
    'bed-size:double/tog-rating:13.5': '13.5 Tog Double Duvets',
    'tog-rating:13.5/type:duvets': '13.5 Tog Duvets',
    'bed-size:king-size/tog-rating:13.5': '13.5 Tog King Size Duvets',
    'bed-size:single/tog-rating:13.5': '13.5 Tog Single Duvets',
    'bed-size:super-king/tog-rating:13.5': '13.5 Tog Super King Duvets',
    'bed-size:double/tog-rating:15': '15 Tog Double Duvets',
    'bed-size:king-size/tog-rating:15': '15 Tog King Size Duvets',
    'bed-size:single/tog-rating:15': '15 Tog Single Duvets',
    'bed-size:double/tog-rating:4.5': '4 Tog Double Duvets',
    'tog-rating:4': '4 Tog Duvets',
    'bed-size:king-size/tog-rating:4.5': '4.5 Tog King Size Duvets',
    'bed-size:single/tog-rating:4.5': '4.5 Tog Single Duvets',
    'bed-size:super-king/tog-rating:4.5': '4.5 Tog Super King Duvets',
    'bed-size:double/tog-rating:7.5': '7.5 Tog Double Duvets',
    'tog-rating:7.5': '7.5 Tog Duvets',
    'bed-size:single/tog-rating:7.5': '7.5 Tog Single Duvets',
    'season:all-seasons': 'All Seasons Duvets',
    'bed-size:king-size/season:all-seasons': 'All Seasons King Size Duvets',
    'anti-allergy-type:anti%252Dallergy': 'Anti-allergy Duvets',
    'filling:duck-feather': 'Duck Feather Duvets',
    'type:blankets': 'Duvet Blankets',
    'filling:feather-and-down': 'Feather and Down Duvets',
    'bed-size:king-size/filling:feather-and-down': 'Feather and Down King Size Duvets',
    'filling:microfiber': 'Microfiber Duvets',
    'filling:poly%252Delastane': 'Poly-elastane Duvets',
    'filling:polyester': 'Polyester Duvets',
    'filling:polyester-hollowfibre': 'Polyester Hollowfibre Duvets',
    'brands:silentnight/tog-rating:10.5': 'Silentnight 10.5 Tog Duvets',
    'brands:silentnight/tog-rating:13.5': 'Silentnight 13.5 Tog Duvets',
    'bed-size:single/type:duvet-sets': 'Single Duvet Sets',
    'brands:slumberdown/tog-rating:10.5': 'Slumberdown 10.5 Tog Duvets',
    'brands:slumberdown/tog-rating:13.5': 'Slumberdown 13.5 Tog Duvets',
    'brands:slumberdown/tog-rating:15': 'Slumberdown 15 Tog Duvets',
    'brands:slumberdown/tog-rating:4.5': 'Slumberdown 4.5 Tog Duvets',
    'filling:synthetic': 'Synthetic Duvets',
    'filling:wool': 'Wool Duvets'
  },
  29474: {
    'fabric-finish:brushed': 'Brushed Cotton Bedding Sets',
    'fabric-finish:percale': 'Percale Bedding Sets',
    'fabric-finish:pin-tuck': 'Pin Tuck Bedding Sets',
    'fabric-finish:tufted': 'Tufted Bedding Sets',
    'fabric-finish:waffle': 'Waffle Bedding Sets'
  },
  29475: {
    'type:bed-in-a-bag': 'Kids Bed in a Bag',
    'design:character-%26-novelty': 'Kids Character Bedding',
    'type:coverless-duvet-covers': 'Kids Coverless Duvet Covers',
    'type:fitted-sheets': 'Kids Fitted Sheets',
    'bed-size:toddler': 'Toddler Bedding'
  },
  29476: {
    'type:fitted-sheets': 'Fitted sheets',
    'type:flat-sheets': 'Flat Bed sheets',
    'material:cotton/type:fitted-sheets': 'Cotton Fitted Sheets',
    'bed-size:double/type:fitted-sheets': 'Double Fitted Sheets',
    'bed-size:double/type:flat-sheets': 'Double Flat Sheets',
    'bed-size:double/type:valances': 'Double Valance Sheets',
    'colour-group:greys/type:fitted-sheets': 'Grey Fitted Sheets',
    'bed-size:king-size/type:fitted-sheets': 'King Size Fitted Sheets',
    'bed-size:king-size/type:flat-sheets': 'King Size Flat Sheets',
    'colour-group:reds/type:fitted-sheets': 'Red Fitted Sheets',
    'bed-size:single/type:fitted-sheets': 'Single Fitted Sheets',
    'bed-size:single/type:flat-sheets': 'Single Flat Sheets',
    'bed-size:single/type:valances': 'Single Valance Sheets',
    'bed-size:super-king/type:fitted-sheets': 'Super King Fitted Sheets',
    'type:valances': 'Valance Bed Sheets'
  },
  29479: {
    'pack-quantity:2': '2 Pack Pillows',
    'pack-quantity:4': '4 Pack Pillows',
    'pack-quantity:6': '6 Pack Pillows',
    'sleep-position:back': 'Back Sleeper Pillows',
    'type:bolster': 'Bolster Pillows',
    'type:cooling': 'Cooling Pillows',
    'filling:duck-feather': 'Duck Feather Pillows',
    'filling:feather-and-down': 'Feather and Down Pillows',
    'firmness:firm': 'Firm Pillows',
    'sleep-position:front': 'Front Sleeper Pillows',
    'filling:polyester-hollowfibre': 'Hollowfibre Pillows',
    'firmness:medium-firm': 'Medium Firm Pillows',
    'firmness:medium': 'Medium Pillows',
    'type:memory-foam': 'Memory Foam Pillows',
    'filling:natural': 'Natural Pillows',
    'filling:polyester': 'Polyester Pillows',
    'sleep-position:side': 'Side Sleeper Pillows',
    'brands:silentnight/pack-quantity:2': 'Silentnight Packs of 2 Pillows',
    'brands:silentnight/pack-quantity:4': 'Silentnight Packs of 4 Pillows',
    'pack-quantity:1': 'Single Pack Pillows',
    'firmness:soft': 'Soft Pillows',
    'type:v-shape': 'V Shaped Pillows',
    'anti-allergy-type:anti%252Dallergy': 'Anti-allergy Pillows'
  },
  29517: {
    'power-type:electric': 'Electric lawnmowers',
    'power-type:petrol': 'Petrol Lawnmowers'
  },
  29519: {
    'type:pole-hedge-trimmer': 'Pole hedge trimmers'
  },
  29524: {
    'type:portable-pressure-cleaner': 'Portable pressure cleaners'
  },
  29525: {
    'type:alarm-clocks': 'Alarm clocks',
    'type:wall-clocks': 'Wall clocks',
    'brands:acctim/type:alarm-clocks': 'Acctim Alarm Clocks',
    'colour-group:blacks/type:alarm-clocks': 'Black Alarm Clocks',
    'colour-group:blacks/type:wall-clocks': 'Black Wall Clocks',
    'colour-group:browns/type:wall-clocks': 'Brown Wall Clocks',
    'brands:constant/type:alarm-clocks': 'Constant Alarm Clocks',
    'display:digital/type:alarm-clocks': 'Digital Alarm Clocks',
    'colour-group:greens/type:wall-clocks': 'Green Wall Clocks',
    'brands:lifemax': 'Lifemax Alarm Clocks',
    'type:mantel-clocks': 'Mantel Clocks',
    'brands:precision': 'Precision Alarm Clocks',
    'brands:seiko/type:alarm-clocks': 'Seiko Alarm Clocks',
    'type:travel-clocks': 'Travel Alarm Clocks',
    'colour-group:whites/type:alarm-clocks': 'White Alarm Clocks'
  },
  29526: {
    'type:weighted-blankets': 'Weighted blankets',
    'type:hooded-blankets': 'Hooded Blankets'
  },
  29527: {
    'type:cushion-covers': 'Cushion covers',
    'type:cushion-pad': 'Cushion Pads',
    'type:filled-cushions': 'Filled Cushions',
    'style:patterned': 'Patterned Cushions',
    'style:plain': 'Plain Cushions'
  },
  29529: {
    'rug-size:large-%28201%252D240cm%29': 'Large rugs',
    'shape:animal': 'Animal Rugs',
    'shape:circle': 'Circular Rugs',
    'rug-size:extra-large-%28241%252D300cm%29': 'Extra Large Rugs',
    'rug-size:extra-small-%2840%252D127cm%29': 'Extra Small Rugs',
    'rug-pile:flatweave': 'Flat Rugs',
    'colour-group:greys/rug-size:large-%28201%252D240cm%29': 'Greys Large (201-240cm) Rugs',
    'rug-material-type:jute/type:rug': 'Jute Rugs',
    'rug-size:medium-%28181%252D200cm%29': 'Medium Rugs',
    'material-group:natural': 'Natural Rugs',
    'backing:non%252Dslip': 'Non-slip Rugs',
    'shape:rectangle': 'Rectangular Rugs',
    'type:rug-gripper': 'Rug Grippers',
    'rug-pile:shaggy': 'Shaggy Rugs',
    'rug-pile:short-pile': 'Short Pile Rugs',
    'rug-size:small-%28128%252D180cm%29': 'Small Rugs'
  },
  29540: {
    'feature:blackout': 'Blackout blinds',
    'type:roller-blinds': 'Roller blinds',
    'type:venetian-blinds': 'Venetian blinds',
    'type:vertical-blinds': 'Vertical blinds',
    'width-(cm):120': '120cm Wide Blinds',
    'drop-(cm):130': '130cm Drop Blinds',
    'width-(cm):150': '150cm Wide Blinds',
    'drop-(cm):160': '160cm Drop Blinds',
    'width-(cm):170': '170cm Wide Blinds',
    'width-(cm):180': '180cm Wide Blinds',
    'width-(cm):60': '60cm Wide Blinds',
    'width-(cm):90': '90cm Wide Blinds',
    'colour-group:blacks/type:roller-blinds': 'Black Roller Blinds',
    'colour-group:blacks/type:venetian-blinds': 'Black Venetian Blinds',
    'feature:blackout/type:roller-blinds': 'Blackout Roller Blinds',
    'colour-group:blues/type:roller-blinds': 'Blue Roller Blinds',
    'feature:daylight': 'Daylight Blinds',
    'feature:daylight/type:roller-blinds': 'Daylight Roller Blinds',
    'colour-group:greys/type:roller-blinds': 'Grey Roller Blinds',
    'colour-group:greys/type:venetian-blinds': 'Grey Venetian Blinds',
    'colour-group:metallics/type:venetian-blinds': 'Metallic Venetian Blinds',
    'feature:moisture-resistant': 'Moisture Resistant Blinds',
    'colour-group:neutrals/type:roller-blinds': 'Neutral Roller Blinds',
    'colour-group:pinks/type:roller-blinds': 'Pink Roller Blinds',
    'colour-group:whites/type:roller-blinds': 'White Roller Blinds',
    'colour-group:whites/type:venetian-blinds': 'White Venetian Blinds',
    'colour-group:whites/type:vertical-blinds': 'White Vertical Blinds',
    'colour-group:whites/material:wood': 'White Wooden Blinds',
    'material:wood': 'Wooden Blinds',
    'material:wood/type:venetian-blinds': 'Wooden Venetian Blinds'
  },
  29541: {
    'lining:blackout': 'Blackout curtains',
    'type:pencil-pleat': 'Pencil pleat curtains',
    'type:eyelet': 'Eyelet curtains',
    'type:voile-panels': 'Voile panels',
    'type:door': 'Door curtains',
    'curtain-drop:137cm-%2854-in%29': '137cm Drop Curtains',
    'curtain-drop:183cm-%2872-in%29': '183cm (72 Inch) Drop Curtains',
    'curtain-drop:190cm-%2874.8-in%29': '190cm (74.8 Inch) Drop Curtains',
    'curtain-drop:213cm-%2884-in%29': '213cm (84 Inch) Drop Curtains',
    'curtain-drop:229cm-%2890-in%29': '229cm (90 Inch) Drop Curtains',
    'colour-group:blacks/type:eyelet': 'Black Eyelet Curtains',
    'colour-group:blacks/type:pencil-pleat': 'Black Pencil Pleat Curtains',
    'lining:blackout/type:eyelet': 'Blackout Eyelet Curtains',
    'lining:blackout-thermal': 'Blackout Thermal Curtains',
    'lining:blackout-thermal/type:eyelet': 'Blackout Thermal Eyelet Curtains',
    'lining:blackout-thermal/type:pencil-pleat': 'Blackout Thermal Pencil Pleat Curtains',
    'colour-group:blues/type:eyelet': 'Blue Eyelet Curtains',
    'colour-group:blues/type:pencil-pleat': 'Blue Pencil Pleat Curtains',
    'colour-group:greens/type:pencil-pleat': 'Green Pencil Pleat Curtains',
    'colour-group:greys/lining:blackout': 'Grey Blackout Curtains',
    'colour-group:greys/type:eyelet': 'Grey Eyelet Curtains',
    'colour-group:greys/type:pencil-pleat': 'Grey Pencil Pleat Curtains',
    'colour-group:neutrals/type:eyelet': 'Neutral Eyelet Curtains',
    'colour-group:pinks/type:eyelet': 'Pink Eyelet Curtains',
    'colour-group:pinks/type:pencil-pleat': 'Pink Pencil Pleat Curtains',
    'style:plain': 'Plain Curtains',
    'colour-group:reds/type:eyelet': 'Red Eyelet Curtains',
    'lining:sheer': 'Sheer Curtains',
    'lining:thermal': 'Thermal Curtains',
    'lining:unlined': 'Unlined Curtains',
    'colour-group:whites/type:voile-panels': 'White Voile Panels'
  },
  29542: {
    'type:curtain-rings': 'Curtain rings',
    'type:blind-cutters': 'Blind Cutters',
    'type:holdbacks': 'Curtain Holdbacks',
    'type:net-curtain-wires': 'Net Curtain Wires'
  },
  29543: {
    'type:curtain-tracks': 'Curtain tracks'
  },
  29546: {
    'type:beach-towels': 'Beach Towels',
    'type:hand-towels': 'Hand Towels',
    'type:towel-bales-and-sets': 'Towel Bales and Sets'
  },
  29547: {
    'type:freestanding': 'Freestanding Towel rails',
    'type:overdoor': 'Over Door Towel Rails',
    'type:wall-mounted': 'Wall Mounted Towel Rails'
  },
  29550: {
    'type:soap-dispensers-and-holders': 'Soap dispensers'
  },
  29551: {
    'type:body-analyser-scales': 'Body Analyser Scales',
    'type:digital-scales': 'Digital Bathroom Scales',
    'type:mechanical-scales': 'Mechanical Bathroom Scales',
    'type:smart-scales': 'Smart Bathroom Scales'
  },
  29553: {
    'type:figurines': 'Figurines',
    'brands:willow-tree/type:figurines': 'Willow Tree Figurines'
  },
  29554: {
    'type:boxed-candle': 'Boxed Candles',
    'type:gift-set': 'Candle Gift Sets',
    'material:ceramic': 'Ceramic Candles',
    'type:jar-candle': 'Jar Candles',
    'candle-size:large': 'Large Candles',
    'type:multi-wick': 'Multi Wick Candles',
    'type:pillar': 'Pillar Candles',
    'type:tealights': 'Tealights'
  },
  29557: {
    'size-of-frame:a3': 'A3 Picture Frames',
    'size-of-frame:a4': 'A4 Picture Frames',
    'pack-type:gallery-set': 'Gallery Wall Frames',
    'brands:habitat/size-of-frame:a4': 'Habitat A4 Picture Frames',
    'size-of-frame:large-%2861%252D100cm%29': 'Large (61-100cm) Picture Frames',
    'size-of-frame:medium-%2831%252D60cm%29': 'Medium (31-60cm) Picture Frames',
    'type:multi-appeture-frames': 'Multi Aperture Frames',
    'size-of-frame:small-%2810%252D30cm%29': 'Small (10-30cm) Picture Frames',
    'material-of-frame:wood': 'Wooden Picture Frames'
  },
  29558: {
    'type:canvas': 'Canvas Wall Art and Prints',
    'type:framed-print': 'Framed Prints',
    'type:unframed-print': 'Unframed Prints',
    'type:wall-sculptures': 'Wall Sculptures',
    'type:wall-stickers': 'Wall Stickers'
  },
  29559: {
    'type:combination-microwave': 'Combination microwaves',
    'type:microwave-with-grill': 'Microwaves with grill',
    'microwave-power-(w):800': '800W Microwaves',
    'type:standard-microwave': 'Standard Microwaves'
  },
  29560: {
    'type:travel-kettles': 'Travel kettles',
    'type:glass-kettles': 'Glass kettles',
    'type:stove-top': 'Stove top kettles',
    'type:metal-kettles': 'Metal kettles',
    'type:plastic-kettles': 'Plastic kettles'
  },
  29562: {
    'type:bean-to-cup-coffee-machines': 'Bean to cup coffee machines',
    'type:filter-coffee-machines': 'Filter coffee machines',
    'type:pod-coffee-machines': 'Pod coffee machines',
    'type:espresso-coffee-machines': 'Espresso coffee machines'
  },
  29575: {
    'type:deep-fat-fryer': 'Deep fat fryers'
  },
  29589: {
    'material:metal': 'Metal Over Door Hooks'
  },
  29590: {
    'collection:atlas': 'Atlas Storage Units',
    'collection:willow': 'Willow Storage Units',
    'collection:wire': 'Wire Storage Units',
    'collection:zander': 'Zander Storage units',
    'type:storage-chests': 'Storage Chests'
  },
  29593: {
    'type:storage-baskets': 'Plastic Storage Baskets',
    'type:underbed-storage': 'Plastic Under Bed Storage',
    'capacity-(l):10': '10l Boxes and Drawers',
    'capacity-(l):120': '120l Plastic Storage Boxes and Drawers',
    'capacity-(l):18': '18l Plastic Storage Boxes and Drawers',
    'capacity-(l):32': '32l Plastic Storage Boxes and Drawers',
    'capacity-(l):35': '35l Plastic Storage Boxes and Drawers',
    'capacity-(l):40': '40l Plastic Storage Boxes and Drawers',
    'capacity-(l):42': '42l Plastic Storage Boxes and Drawers',
    'capacity-(l):50': '50l Plastic Storage Boxes and Drawers',
    'capacity-(l):62': '62l Plastic Storage Boxes and Drawers',
    'capacity-(l):65': '65l Plastic Storage Boxes and Drawers',
    'capacity-(l):80': '80l Plastic Storage Boxes and Drawers',
    'type:storage-trolleys': 'Plastic Storage Trolleys'
  },
  29595: {
    'type:wrapping': 'Packing Paper and Bubble Wrap'
  },
  29596: {
    'type:overdoor': 'Overdoor Shoe Storage',
    'colour-group:woods': 'Wooden Shoe Storage',
    'material:metal': 'Metal Shoe Storage Racks',
    'type:boxes-and-bags': 'Shoe Bags and Boxes',
    'type:shoe-benches': 'Shoe Benches',
    'width-(cm):50': '50cm Wide Shoe Storage',
    'width-(cm):60': '60cm Wide Shoe Storage',
    'width-(cm):70': '70cm Wide Shoe Storage',
    'width-(cm):80': '80cm Wide Shoe Storage'
  },
  29597: {
    'type:vacuum-storage-bags': 'Vacuum storage bags'
  },
  29598: {
    'type:5-drawer-chest': '5 drawer Chest of drawers',
    'type:tallboy': 'Tall Chest of drawers',
    'assembly:fully-assembled': 'Fully assembled Chest of drawers',
    'type:2-drawer-chest': '2 Drawer Chests of Drawers',
    'type:3-drawer-chest': '3 Drawer Chests of Drawers',
    'type:4-drawer-chest': '4 Drawer Chests of Drawers',
    'type:6-drawer-chest': '6 Drawer Chests of Drawers',
    'type:7-drawer-chest': '7 Drawer Chests of Drawers',
    'collection:amelie': 'Amelie Chests of Drawers',
    'collection:bergen': 'Bergen Chests of Drawers',
    'collection:derwent': 'Derwent Chests of Drawers',
    'collection:munich': 'Munich Chests of Drawers',
    'collection:nordic': 'Nordic Chests of Drawers',
    'collection:oslo': 'Oslo Chests of Drawers',
    'collection:scandinavia': 'Scandinavia Chests of Drawers',
    'collection:seville': 'Seville Chests of Drawers',
    'collection:sherwood': 'Sherwood Chest of drawers',
    'colour-group:whites/type:3-drawer-chest': 'White 3 Drawer Chests of Drawers',
    'colour-group:whites/type:5-drawer-chest': 'White 5 Drawer Chests of Drawers'
  },
  29599: {
    'collection:jenson': 'Jenson Bedroom Furniture',
    'collection:seville': 'Seville Bedroom Furniture'
  },
  29601: {
    'type:sliding': 'Sliding wardrobes',
    'type:3-door-wardrobes': '3 Door Wardrobes',
    'type:4-door-wardrobes': '4 Door Wardrobes',
    'type:2-door-wardrobes': '2 Door Wardrobes',
    'type:6-door-wardrobes': '6 door Wardrobes',
    'type:1-door-wardrobes': '1 door Wardrobes',
    'assembly:fully-assembled': 'Fully assembled Wardrobes',
    'type:5-door-wardrobes': '5 Door Wardrobes',
    'collection:amelie': 'Amelie Wardrobes',
    'collection:atlas': 'Atlas Wardrobes',
    'collection:bergen': 'Bergen Wardrobes',
    'colour-group:blacks/type:3-door-wardrobes': 'Black 3 Door Wardrobes',
    'type:corner-wardrobes': 'Corner Wardrobes',
    'collection:derwent': 'Derwent Wardrobes',
    'assembly:minimal-assembly': 'Easy to Assemble Wardrobes',
    'assembly:packed-flat': 'Flat Pack Wardrobes',
    'colour-group:greys/type:2-door-wardrobes': 'Grey 2 Door Wardrobes',
    'colour-group:greys/type:3-door-wardrobes': 'Grey 3 Door Wardrobes',
    'colour-group:greys/type:4-door-wardrobes': 'Grey 3 Door Wardrobes',
    'brands:habitat/type:sliding': 'Habitat Sliding Wardrobes',
    'collection:hallingford': 'Hallingford Wardrobes',
    'collection:holsted': 'Holsted Wardrobes',
    'collection:jenson': 'Jenson Wardrobes',
    'collection:kensington': 'Kensington Wardrobes',
    'collection:kent': 'Kent Wardrobes',
    'collection:lancaster': 'Lancaster Wardrobes',
    'collection:legato': 'Legato Wardrobes',
    'collection:malibu': 'Malibu Wardrobes',
    'collection:minato': 'Minato Wardrobes',
    'collection:munich': 'Munich Wardrobes',
    'collection:nomad': 'Nomad Wardrobes',
    'collection:nordic': 'Nordic Wardrobes',
    'collection:oslo': 'Oslo Wardrobes',
    'collection:puerto-rico': 'Puerto Rico Wardrobes',
    'assembly:fully-assembled/type:2-door-wardrobes': 'Ready Assembled 2 Door Wardrobes',
    'assembly:fully-assembled/type:3-door-wardrobes': 'Ready Assembled 3 Door Wardrobes',
    'assembly:fully-assembled/type:4-door-wardrobes': 'Ready Assembled 4 Door Wardrobes',
    'assembly:fully-assembled/colour-group:whites': 'Ready Assembled White Wardrobes',
    'collection:scandinavia': 'Scandinavia Wardrobes',
    'assembly:self%252Dassembly': 'Self Assembly Wardrobes',
    'collection:seville': 'Seville Wardrobes',
    'collection:sherwood': 'Sherwood Wardrobes',
    'assembly:self%252Dassembly/material-type:solid-wood': 'Solid Wood Self Assembly Wardrobes',
    'type:wardrobe-frames': 'Wardrobe Frames',
    'drawers:yes': 'Wardrobes with Drawers',
    'colour-group:whites/type:2-door-wardrobes': 'White 2 Door Wardrobes',
    'colour-group:whites/type:3-door-wardrobes': 'White 3 Door Wardrobes',
    'colour-group:whites/type:4-door-wardrobes': 'White 4 Door Wardrobes',
    'colour-group:whites/type:sliding': 'White Sliding Wardrobes'
  },
  29603: {
    'collection:canzano': 'Canzano Bedside Tables',
    'collection:derwent': 'Derwent Bedside Tables',
    'collection:kensington': 'Kensington Bedside Tables',
    'collection:minato': 'Minato Bedside Tables',
    'collection:nordic': 'Nordic Bedside tables',
    'assembly:fully-assembled': 'Ready Assembled Bedside Tables'
  },
  29604: {
    'type:stool': 'Dressing Table Stools',
    'type:dressing-table-with-mirror-and-stool': 'Dressing Tables with Mirror and Stool',
    'type:dressing-table-with-stool': 'Dressing Tables with Stool',
    'assembly:fully-assembled': 'Ready Assembled Dressing tables',
    'collection:scandinavia': 'Scandinavia Dressing tables'
  },
  29605: {
    'collection:shaker': 'Shaker Sliding Wardrobe Doors',
    'collection:spacepro': 'Spacepro Sliding Wardrobe Doors'
  },
  29612: {
    'type:integrated-washing-machines': 'Integrated washing machines'
  },
  29614: {
    'type:condenser-tumble-dryers': 'Condenser tumble dryers',
    'type:heat-pump-tumble-dryers': 'Heat pump tumble dryers',
    'type:vented-tumble-dryers': 'Vented tumble dryers',
    'sensor-dry:yes': 'Tumble dryers with Sensor dry'
  },
  29615: {
    'type:fully-integrated': 'Integrated Dishwashers'
  },
  29616: {
    'type:under-counter-fridges': 'Under counter fridges',
    'type:tall-upright-fridges': 'Tall fridges',
    'type:table-top-fridges': 'Table top fridges',
    'type:wine-coolers': 'Wine coolers'
  },
  29617: {
    'type:american-fridge-freezers': 'American Fridge Freezers',
    'type:under-counter-fridge-freezers': 'Under counter Fridge freezers',
    'water-and-ice-dispenser:water-dispenser-only': 'Fridge freezers with Water dispenser',
    'frost-free-type:frost-free': 'Frost free Fridge freezers'
  },
  29618: {
    'type:chest-freezers': 'Chest Freezers',
    'type:under-counter-freezers': 'Under counter freezers',
    'type:tall-freezers': 'Tall freezers',
    'type:tabletop-freezers': 'Table top freezers'
  },
  29623: {
    'type:electric-cookers': 'Freestanding Electric Cookers',
    'type:dual-fuel-cookers': 'Dual fuel Freestanding cookers',
    'type:gas-cookers': 'Gas cookers'
  },
  29624: {
    'type:built%252Dunder-double-oven': 'Built-under double ovens',
    'type:built%252Din-single-oven': 'Built-in single ovens'
  },
  29625: {
    'type:induction': 'Induction hobs',
    'type:gas': 'Gas hobs',
    'type:ceramic': 'Ceramic Hobs'
  },
  29641: {
    'type:cuddle-chairs': 'Cuddle chairs',
    'type:rise-and-recline': 'Rise and recline Armchairs',
    'type:high-back-chairs': 'High back Chairs',
    'collection:alexis': 'Alexis Armchairs and Chairs',
    'collection:argyll': 'Argyll Armchairs and Chairs',
    'collection:bentwood': 'Bentwood Armchairs and Chairs',
    'colour-group:blacks/type:recliner-chairs': 'Black Leather Recliner Chairs',
    'collection:bradley': 'Bradley Armchairs and Chairs',
    'colour-group:browns/type:cuddle-chairs': 'Brown Cuddle Chairs',
    'colour-group:browns/type:recliner-chairs': 'Brown Recliner Chairs',
    'colour-group:browns/type:tub-chairs': 'Brown Tub Chairs',
    'collection:callie': 'Callie Armchairs and Chairs',
    'collection:celine': 'Celine Armchairs and Chairs',
    'type:chairs-with-footstool': 'Chairs with Footstools',
    'collection:charles': 'Charles Armchairs and Chairs',
    'collection:chester': 'Chester Armchairs and Chairs',
    'collection:chesterfield': 'Chesterfield Armchairs and Chairs',
    'collection:cole': 'Cole Armchairs and Chairs',
    'collection:delilah': 'Delilah Armchairs and Chairs',
    'collection:eppy': 'Eppy Armchairs and Chairs',
    'collection:evie': 'Evie Armchairs and Chairs',
    'material-type:fabric/type:cuddle-chairs': 'Fabric Cuddle Chairs',
    'material-type:fabric/type:recliner-chairs': 'Fabric Recliner Chairs',
    'collection:florence': 'Florence Armchairs and Chairs',
    'colour-group:greys/type:cuddle-chairs': 'Grey Cuddle Chairs',
    'colour-group:greys/type:tub-chairs': 'Grey Tub Chairs',
    'collection:jacob': 'Jacob Armchairs and Chairs',
    'collection:julien': 'Julien Armchairs and Chairs',
    'material-type:leather/type:recliner-chairs': 'Leather Recliner Chairs',
    'collection:lisbon': 'Lisbon Armchairs and Chairs',
    'collection:milano': 'Milano Armchairs and Chairs',
    'type:recliner-chairs': 'Recliner Chairs',
    'type:rocking': 'Rocking Chairs',
    'collection:salisbury': 'Salisbury Armchairs and Chairs',
    'collection:santos': 'Santos Armchairs and Chairs',
    'type:swivel-chairs': 'Swivel Chairs',
    'collection:toby': 'Toby Armchairs and Chairs',
    'type:tub-chairs': 'Tub Chairs',
    'collection:valencia': 'Valencia Armchairs and Chairs',
    'collection:warwick': 'Warwick Armchairs and Chairs',
    'type:wingback': 'Wingback Armchairs and Chairs'
  },
  29642: {
    'collection:chesterfield': 'Chesterfield Footstool',
    'collection:milano': 'Milano Footstool',
    'collection:moroccan': 'Moroccan Footstool'
  },
  29643: {
    'type:2-seater': '2 seater sofas',
    'type:3-seater': '3 seater sofas',
    'type:corner': 'Corner sofas',
    'type:recliner': 'Recliner sofas',
    'type:4-seater': '4 Seater Sofas',
    'type:corner-recliner': 'Corner Recliner Sofas',
    'collection:evie': 'Evie Sofas',
    'material-type:fabric/type:2-seater': 'Fabric 2 Seater Sofas',
    'colour-group:greys/type:corner': 'Grey Corner Sofas',
    'brands:habitat/type:corner': 'Habitat Corner Sofas',
    'collection:harry': 'Harry Sofas',
    'collection:hendricks': 'Hendricks Sofas',
    'collection:joshua': 'Joshua Sofas',
    'material-type:leather/type:2-seater': 'Leather 2 Seater Sofas',
    'material-type:leather/type:corner': 'Leather Corner Sofas',
    'collection:milano': 'Milano Sofas',
    'collection:swift': 'Swift Sofas',
    'collection:valencia': 'Valencia Sofas',
    'collection:chesterfield': 'Chesterfield Sofas',
    'collection:chesterfield/type:2-seater': 'Chesterfield 2 seater Sofas',
    'collection:florence': 'Florence Sofas',
    'collection:jackson': 'Jackson Sofas',
    'collection:julien': 'Julien Sofas',
    'collection:milano/material-type:leather': 'Milano Leather Sofas',
    'collection:moda': 'Moda Sofas',
    'collection:taylor': 'Taylor Sofas',
    'colour-group:blues/type:3-seater': 'Blue 3 Seater Sofas',
    'colour-group:browns/type:2-seater': 'Brown 2 Seater Sofas',
    'colour-group:browns/type:recliner': 'Brown Recliner Sofas',
    'colour-group:greens/type:2-seater': 'Green 2 Seater Sofas',
    'colour-group:greens/type:3-seater': 'Green 3 Seater Sofas',
    'colour-group:greys/type:2-seater': 'Grey 2 Seater Sofas',
    'colour-group:greys/type:3-seater': 'Grey 3 Seater Sofas',
    'material-type:fabric/type:3-seater': 'Fabric 3 Seater Sofas',
    'material-type:fabric/type:corner': 'Fabric Corner Sofas',
    'material-type:fabric/type:recliner': 'Fabric Recliner Sofas',
    'material-type:leather/type:3-seater': 'Leather 3 Seater Sofas',
    'material-type:leather/type:4-seater': 'Leather 4 Seater Sofas',
    'material-type:velvet/type:2-seater': 'Velvet 2 Seater Sofas',
    'material-type:velvet/type:3-seater': 'Velvet 3 Seater Sofas',
    'type:modular-sofas-and-chairs': 'Modular Sofas and Chairs',
    'type:small': 'Small Sofas'
  },
  29644: {
    'type:futon': 'Futons',
    'type:chair-beds': 'Chair beds',
    'type:corner': 'Corner Sofa beds',
    'collection:duo': 'Duo Sofa Beds',
    'collection:mexico': 'Mexico Sofa Beds',
    'collection:miller': 'Miller Sofa Beds',
    'collection:roma': 'Roma Sofa Beds',
    'bed-size:single/type:chair-beds': 'Single Chair Beds',
    'bed-size:double/type:futon': 'Double Futon Sofa Beds',
    'collection:apartment': 'Apartment Sofa Beds',
    'collection:aurora': 'Aurora Sofa Beds',
    'collection:chase': 'Chase Sofa Beds',
    'collection:ethan': 'Ethan Sofa Beds',
    'collection:lucy': 'Lucy Sofa Beds',
    'collection:matteo': 'Matteo Sofa Beds',
    'collection:patsy': 'Patsy Sofa Beds',
    'colour-group:blacks/type:chair-beds': 'Black Chair Beds',
    'colour-group:blacks/type:futon': 'Black Futons',
    'colour-group:greys/type:futon': 'Grey Futons'
  },
  29645: {
    'type:2-and-3-seater': '2 and 3 seater Sofa sets',
    'type:chair-and-2-seater': '2 Seater Sofa and Chair Sets',
    'type:chair-and-3-seater': '3 Seater Sofa and Chair Sets',
    'type:chair-and-4-seater': '4 Seater Sofa and Chair Sets'
  },
  29647: {
    'max-seating-capacity:4': '4 Seater Dining table and chairs',
    'table-type:extendable': 'Extendable Dining table and chair sets',
    'table-height-(cm):70': '70cm High Dining Table and Chair Sets',
    'collection:butterfly': 'Butterfly Dining Table and Chair Sets',
    'collection:chicago': 'Chicago Dining Table and Chair Sets',
    'max-seating-capacity:2': 'Dining Tables with 2 Chairs',
    'max-seating-capacity:5': 'Dining Tables with 5 Chairs',
    'max-seating-capacity:6': 'Dining Tables with 6 Chairs',
    'max-seating-capacity:8': 'Dining Tables with 8 Chairs',
    'table-type:folding': 'Folding Dining Table and Chair Sets',
    'table-top-finish:glass': 'Glass Dining Table and Chair Sets',
    'table-top-finish:gloss': 'Gloss Dining Table and Chair Sets',
    'collection:haversham': 'Haversham Dining Table and Chair Sets',
    'collection:haversham/customer-rating:3-stars-or-more': 'Haversham Dining Table and Chair Sets',
    'collection:miami': 'Miami Dining Table and Chair Sets',
    'collection:nomad': 'Nomad Dining Table and Chair Sets',
    'table-top-finish:oak': 'Oak Dining Table and Chair Sets',
    'shape:oval': 'Oval Dining Table and Chair Sets',
    'table-top-finish:plastic': 'Plastic Dining Table and Chair Sets',
    'shape:rectangular': 'Rectangular Dining Table and Chair Sets',
    'shape:round': 'Round Dining Table and Chair Sets',
    'collection:skandi': 'Skandi Dining Table and Chair Sets',
    'table-top-finish:solid-wood': 'Solid Wood Dining Table and Chair Sets',
    'shape:square': 'Square Dining Table and Chair Sets',
    'collection:stella': 'Stella Dining Table and Chair Sets',
    'table-top-finish:wood-effect': 'Wood Effect Dining Table and Chair Sets',
    'table-top-finish:wood-veneer': 'Wood Veneer Dining Table and Chair Sets'
  },
  29648: {
    'shape:round': 'Round dining tables',
    'type:extendable': 'Extendable dining tables',
    'collection:alice': 'Alice Dining tables',
    'collection:ashdon': 'Ashdon Dining tables',
    'collection:blake': 'Blake Dining tables',
    'collection:drew': 'Drew Dining tables',
    'type:folding': 'Folding Dining Tables',
    'collection:heath': 'Heath Dining tables',
    'collection:lincoln': 'Lincoln Dining tables',
    'colour-group:oak/type:extendable': 'Oak Extendable Dining Tables',
    'collection:otis': 'Otis Dining tables',
    'shape:oval': 'Oval Dining Tables',
    'collection:radius': 'Radius Dining tables',
    'assembly:fully-assembled': 'Ready Assembled Dining Tables',
    'shape:rectangular': 'Rectangular Dining Tables',
    'shape:square': 'Square Dining Tables',
    'collection:tulip': 'Tulip Dining tables',
    'seats:up-to-10': 'Up to 10 Seater Dining Tables',
    'colour-group:white/type:extendable': 'White Extendable Dining Tables',
    'colour-group:white/shape:rectangular': 'White Rectangular Dining Tables'
  },
  29649: {
    'collection:bentwood': 'Bentwood Dining Chairs',
    'type:benches': 'Dining Benches',
    'type:folding-chairs': 'Folding Dining Chairs',
    'collection:industrial': 'Industrial Dining Chairs',
    'collection:miami': 'Miami Dining Chairs',
    'assembly:fully-assembled': 'Ready Assembled Dining Chairs',
    'set-size:set-of-2-chairs': 'Sets of 2 Dining Chairs',
    'set-size:set-of-4-chairs': 'Sets of 4 Dining Chairs',
    'set-size:set-of-6-chairs': 'Sets of 6 Dining Chairs',
    'set-size:single-chairs': 'Single Dining Chairs',
    'type:upholstered-chairs': 'Upholstered Dining Chairs'
  },
  29650: {
    'table-type:extendable': 'Extendable Space Saving Dining Sets',
    'max-seating-capacity:2': 'Space Saving Dining Sets for 2',
    'max-seating-capacity:4': 'Space Saving Dining Sets for 4'
  },
  29651: {
    'adjustable-height:yes': 'Adjustable Height Bar Stools',
    'type:upholstered-bar-stools': 'Upholstered Bar Stools'
  },
  29653: {
    'type:stepladder': 'Stepladders',
    'type:combination-ladders': 'Combination ladders',
    'type:telescopic-ladders': 'Telescopic ladders'
  },
  29668: {
    'type:circular-saws': 'Circular saws',
    'type:jigsaws': 'Electric jigsaws'
  },
  29675: {
    'type:drill-drivers': 'Drill drivers'
  },
  29685: {
    'type:1-door-wardrobes': 'Kids 1 Door Wardrobes',
    'type:2-door-wardrobes': 'Kids 2 Door Wardrobes',
    'type:3-door-wardrobes': 'Kids 3 Door Wardrobes'
  },
  29690: {
    'type:mop-sets': 'Mop and Bucket Sets'
  },
  29693: {
    'type:robot': 'Robot Vacuums',
    'type:bagless-upright': 'Bagless upright Vacuum cleaners',
    'type:bagless-cylinder': 'Bagless cylinder Vacuum cleaners'
  },
  29695: {
    'type:spot-cleaner': 'Spot cleaner Carpet cleaners'
  },
  29709: {
    'type:colanders': 'Colanders'
  },
  29712: {
    'type:recycling-bins': 'Recycling bins',
    'lid-mechanism:pedal': 'Pedal bins',
    'type:sensor-bin': 'Sensor bins',
    'capacity-(l):10': '10 Litre Kitchen Bins',
    'capacity-(l):20': '20 Litre Kitchen Bins',
    'capacity-(l):25': '25 Litre Kitchen Bins',
    'capacity-(l):30': '30 Litre Kitchen Bins',
    'capacity-(l):40': '40 Litre Kitchen Bins',
    'capacity-(l):50': '50 Litre Kitchen Bins',
    'capacity-(l):60': '60 Litre Kitchen Bins',
    'capacity-(l):70': '70 Litre Kitchen Bins',
    'type:bin-liners': 'Bin Liners',
    'colour-group:blacks/type:recycling-bins': 'Blacks Recycling Bins',
    'brands:brabantia/type:bin-liners': 'Brabantia Bin Liners',
    'type:built%252Din-bins': 'Built-in Cupboard Bins',
    'brands:habitat/type:recycling-bins': 'Habitat Recycling Bins',
    'lid-mechanism:touch-top': 'Kitchen Touch Top Bins',
    'colour-group:metallics/type:recycling-bins': 'Metallic Recycling Bins',
    'lid-mechanism:roll-top': 'Roll Top Kitchen Bins',
    'brands:simplehuman/type:bin-liners': 'simplehuman Bin Liners',
    'brands:simplehuman/type:recycling-bins': 'simplehuman Recycling Bins',
    'type:slim-bins': 'Slim Kitchen Bins'
  },
  29713: {
    '': 'Kitchen Starter Sets'
  },
  29714: {
    'type:knife-sharpeners': 'Knife sharpeners',
    'in-set:5': '5 Piece Knife Sets',
    'in-set:6': '6 Piece Knife Sets'
  },
  29716: {
    'type:mechanical-kitchen-scales': 'Mechanical Kitchen Scales'
  },
  29719: {
    'type:aprons': 'Aprons',
    'type:tea-towels': 'Tea Towels'
  },
  29720: {
    'type:hostess-trolleys': 'Hostess Trolleys'
  },
  29728: {
    'type:baking-trays-and-sheets': 'Baking trays',
    'type:muffin-trays': 'Muffin trays',
    'type:bakeware-sets': 'Baking Sets',
    'type:cake-tins': 'Cake Tins',
    'brands:circulon': 'Circulon Cake Tins and Baking Trays',
    'type:loaf-tins': 'Loaf Tins',
    'brands:masterclass': 'Masterclass Cake Tins and Baking Trays',
    'type:pizza-tins-and-trays': 'Pizza Trays',
    'brands:prestige': 'Prestige Baking Trays',
    'type:quiche-tins': 'Quiche Tins'
  },
  29732: {
    cerami: 'Ceramic Frying Pans and Skillets',
    electri: 'Frying Pans for Electric Hobs',
    'gas:yes': 'Frying Pans for Gas Hobs',
    'halogen:yes': 'Frying Pans for Halogen Hobs',
    'induction:yes': 'Frying Pans for Induction Hobs',
    'type:saute-pans': 'Sauté Pans'
  },
  29733: {
    'type:chip-pans': 'Chip pans',
    'type:egg-poachers': 'Egg poachers',
    cerami: 'Ceramic Saucepans',
    'type:milk-pans': 'Milk Pans',
    'type:stock-and-casserole-pots': 'Stock Pots'
  },
  29734: {
    'induction:yes': 'Induction Pan sets'
  },
  29735: {
    'capacity-(l):3': '3 Litre Pressure Cookers',
    'capacity-(l):4': '4 Litre Pressure Cookers',
    'capacity-(l):5.5': '5.5 Litre Pressure Cookers',
    'capacity-(l):6': '6 Litre Pressure Cookers',
    'capacity-(l):7': '7 Litre Pressure Cookers',
    'capacity-(l):8': '8 Litre Pressure Cookers'
  },
  29736: {
    '': 'Steamer Pans'
  },
  29738: {
    'type:ramekins': 'Ramekin Dishes',
    'type:trivets': 'Trivets'
  },
  29741: {
    'type:wine-glasses': 'Wine glasses',
    'type:gin-glasses': 'Gin glasses',
    'type:whisky-glasses': 'Whisky glasses',
    'type:champagne-glasses': 'Champagne glasses',
    'type:cocktail-glasses': 'Cocktail glasses',
    'type:hi-ball-glasses': 'Hi ball glasses',
    'type:carafe': 'Carafes',
    'type:tumblers': 'Tumbler glasses',
    'type:coffee-glasses': 'Coffee Glasses',
    'pieces:2': 'Sets of 2 Glasses',
    'pieces:4': 'Sets of 4 Glasses',
    'pieces:6': 'Sets of 6 Glasses',
    'pieces:12': 'Sets of 12 Glasses',
    'type:martini-glasses': 'Martini Glasses',
    'type:mixed-sets': 'Mixed Glasses Sets',
    'type:pint-glasses': 'Pint Glasses',
    'type:serve-jugs': 'Serve Jugs'
  },
  29742: {
    'number-of-pieces:12': '12 Piece Cutlery Sets',
    'number-of-pieces:16': '16 Piece Cutlery Sets',
    'number-of-pieces:32': '32 Piece Cutlery Sets',
    'colour-group:blacks': 'Black Cutlery Sets',
    'colour-group:blues': 'Blue Cutlery Sets',
    'colour-group:golds': 'Gold Cutlery Sets',
    'colour-group:greys': 'Grey Cutlery Sets',
    'colour-group:reds': 'Red Cutlery Sets',
    'material:stainless-steel': 'Stainless Steel Cutlery Sets'
  },
  29743: {
    'place-settings:4': 'Dinner Sets for 4 People',
    'place-settings:6': 'Dinner Sets for 6 People',
    'offers-and-clearance:clearance': 'Clearance Dinner Sets'
  },
  29744: {
    'type:snack-boxes': 'Kids Snack Boxes',
    'colour-group:blacks': 'Black Lunch Boxes and Bags',
    'type:lunch-box-and-bottle-set': 'Lunch Box and Bottle Sets'
  },
  29745: {
    'type:nibble-bowl': 'Nibble Bowls',
    'type:pizza-board': 'Pizza Boards',
    'type:salad-bowl': 'Salad Bowls',
    'type:tapas-bowl': 'Tapas Bowls',
    'type:serve-board': 'Serve Boards',
    'type:serving-platter': 'Serving Platters'
  },
  29749: {
    'animal-type:chicken': 'Chicken Coops and Hen Houses'
  },
  29752: {
    'cover-material:fleece': 'Fleece Cat Beds'
  },
  29765: {
    'type:collars': 'Dog Collars',
    'type:harnesses': 'Dog Harnesses',
    'type:leads': 'Dog Leads'
  },
  29767: {
    'brands:wahl': 'Wahl Dog Clippers'
  },
  29768: {
    'brands:yumove': 'YuMOVE Dog Supplements'
  },
  29771: {
    'type:safety-guard': 'Dog Guards for Cars',
    'accessory-type:boot-liners': 'Car Boot Liners',
    'type:surface-protector': 'Dog Car Surface Protectors'
  },
  29772: {
    'type:blankets': 'Dog Blankets',
    'type:soft-beds': 'Soft Dog Beds',
    'cover-material:fleece': 'Fleece Dog Beds',
    'type:baskets': 'Dog Baskets'
  },
  29773: {
    'type:brain-training-toys': 'Dog Brain Training Toys',
    'type:chew-toys': 'Dog Chew Toys',
    'type:rope-toys': 'Dog Rope Toys',
    'type:throwing-toys': 'Dog Throwing Toys'
  },
  29786: {
    'animal-type:hamsters-and-mice': 'Hamster and Mice Cages',
    'brands:rosewood': 'Rosewood Hamster Cages and Small Animal Homes'
  },
  29787: {
    'animal-type:rabbits-and-guinea-pigs': 'Rabbit and Guinea Pig Hutches and Runs'
  },
  29802: {
    'type:spotlights': 'Ceiling spotlights',
    'type:chandeliers': 'Chandeliers',
    'type:cluster-lights': 'Cluster Lights',
    'type:flush-to-ceiling': 'Flush to Ceiling Lights',
    'brands:habitat/type:pendants': 'Habitat Pendant Lights',
    'type:pendants': 'Pendants Ceiling Lights',
    'brands:philips/type:spotlights': 'Philips Spotlights',
    'colour-group:whites/type:spotlights': 'White Spotlights'
  },
  29803: {
    'base-material:glass': 'Glass Table Lamps'
  },
  29804: {
    'type:arc-lamps': 'Arc Floor Lamps',
    'type:column-lamps': 'Column Floor Lamps',
    'type:multi%252Dhead-lamps': 'Multi-head Floor Lamps',
    'type:stick-lamps': 'Stick Floor Lamps',
    'type:tripod-lamps': 'Tripod Floor Lamps'
  },
  29805: {
    'brands:lava': 'Lava Lamps'
  },
  29806: {
    'type:desk-lamps': 'Kids Desk Lamps',
    'type:night-light': 'Kids Night Lights',
    'type:string-lights': 'Kids String Lights',
    'type:table-and-bedside-lamps': 'Kids Table and Bedside Lamps',
    'type:wall-lights': 'Kids Wall Lights'
  },
  29808: {
    'watts:11': '11w Light Bulbs',
    'watts:12': '12w Light Bulbs',
    'watts:15': '15w Light Bulbs',
    'watts:1': '1w Light Bulbs',
    'watts:25': '25w Light Bulbs',
    'watts:28': '28w Light Bulbs',
    'watts:40': '40w Light Bulbs',
    'watts:4': '4w Light Bulbs',
    'watts:5': '5w Light Bulbs',
    'watts:60': '60w Light Bulbs',
    'watts:6': '6w Light Bulbs',
    'watts:7': '7w Light Bulbs',
    'watts:9': '9w Light Bulbs',
    'fitting:bayonet-cap-%28bc%29': 'Bayonet Cap (BC) Light Bulbs',
    'can-be-used-with-a-dimmer-switch:yes': 'Dimmable Light Bulbs',
    'fitting:edison-screw-%28es%29': 'Edison Screw (ES) Light bulbs',
    'fitting:gu10': 'GU10 Light Bulbs',
    'fitting:r7': 'R7 Light Bulbs',
    'fitting:small-edison-screw-%28ses%29': 'Small Edison Screw (SES) Light Bulbs'
  },
  29817: {
    'tree-shape:slim': 'Slim Christmas trees',
    'lights:fibre-optic': 'Fibre optic Christmas trees',
    'height-(ft):10': '10ft Christmas Trees',
    'height-(ft):3': '3ft Christmas Trees',
    'height-(ft):4': '4ft Christmas Trees',
    'height-(ft):5': '5ft Christmas Trees',
    'height-(ft):7': '7ft Christmas Trees',
    'height-(ft):8': '8ft Christmas Trees',
    'tree-shape:full': 'Full Christmas Trees',
    'tree-shape:split-in-half': 'Half Christmas Trees',
    'lights:pre%252Dlit': 'Pre-lit Christmas Trees'
  },
  29818: {
    'type:icicle': 'Icicle Christmas lights',
    'type:cluster': 'Cluster Christmas lights',
    'type:window-and-net': 'Christmas Window & Net lights',
    'type:projector': 'Christmas Projector Lights',
    'usage:indoor-and-outdoor': 'Indoor and Outdoor Christmas Lights',
    'usage:indoor': 'Indoor Christmas Lights',
    'usage:outdoor': 'Outdoor Christmas Lights',
    'colour:warm-white/type:icicle': 'Warm White Icicle Christmas Lights',
    'colour:warm-white/usage:indoor-and-outdoor': 'Warm White Indoor and Outdoor Christmas Lights'
  },
  29845: {
    'type:tree-topper': 'Christmas Tree Toppers'
  },
  29859: {
    'type:tall-boys': 'Tall bathroom cabinets',
    'type:trolleys': 'Bathroom Trolleys',
    'assembly:fully-assembled': 'Fully Assembled Freestanding Bathroom Cabinets'
  },
  29860: {
    'mirrored:yes': 'Mirrored Bathroom cabinets'
  },
  29862: {
    'adjustable-seat-height:yes': 'Office Chairs with Adjustable Seat Height'
  },
  29863: {
    'type:corner-desks': 'Corner desks',
    'type:gaming-desks': 'Gaming desks',
    'width-(cm):120': '120cm Desks',
    'width-(cm):140': '140cm Desks',
    'width-(cm):65': '65cm Desks',
    'assembly:packed-flat': 'Flat Pack Desks',
    'assembly:fully-assembled': 'Ready Assembled Desks',
    'height-(cm):75': '75cm High Desks',
    'type:trolleys': 'Trolley Desks',
    'type:workstations': 'Desk Workstations',
    'width-(cm):100': '100cm Wide Desks',
    'width-(cm):110': '110cm Wide Desks',
    'width-(cm):115': '115cm Wide Desks',
    'width-(cm):130': '130cm Wide Desks',
    'width-(cm):150': '150cm Wide Desks',
    'width-(cm):160': '160cm Wide Desks',
    'width-(cm):60': '60cm Wide Desks',
    'width-(cm):80': '80cm Wide Desks',
    'width-(cm):90': '90cm Wide Desks'
  },
  29864: {
    'type:document-storage': 'Document Storage Boxes'
  },
  29866: {
    'storage-options:2-storage-drawers': 'Divan Beds with 2 Drawers',
    'storage-options:4-storage-drawers': 'Divan Beds with 4 Drawers',
    'size:double/storage-options:4-storage-drawers': 'Double Divan Beds with 4 Drawers',
    'mattress-firmness:medium': 'Medium Divan Beds',
    'brands:sealy/storage-options:4-storage-drawers': 'Sealy 4 Drawer Divan Beds',
    'size:single/storage-options:2-storage-drawers': 'Single Divan Beds with 2 Drawers'
  },
  29867: {
    'frame-finish:wooden': 'Wooden bed frames',
    'frame-finish:metal': 'Metal Bed frames',
    'collection:atlas': 'Atlas Bed Frames',
    'collection:ava': 'Ava Bed Frames',
    'colour-group:black/frame-finish:metal': 'Black Metal Bed Frames',
    'frame-finish:faux-leather/size:double': 'Double Faux Leather Bed Frames',
    'frame-finish:upholstered/size:double': 'Double Upholstered and Fabric Bed Frames',
    'frame-finish:velvet/size:double': 'Double Velvet Bed Frames',
    'frame-finish:wooden/size:double': 'Double Wooden Bed Frames',
    'frame-finish:faux-leather': 'Faux Leather Bed Frames',
    'frame-finish:faux-leather/size:king-size': 'King Size Faux Leather Bed Frames',
    'frame-finish:upholstered/size:king-size': 'King Size Upholstered and Fabric Bed Frames',
    'frame-finish:velvet/size:king-size': 'King Size Velvet Bed Frames',
    'frame-finish:wooden/size:king-size': 'King Size Wooden Bed Frames',
    'frame-finish:metal/size:double': 'Metal Double Bed Frames',
    'frame-finish:metal/size:king-size': 'Metal King Size Bed Frames',
    'frame-finish:metal/size:single': 'Metal Single Bed Frames',
    'frame-finish:metal/size:small-double': 'Metal Small Double Bed Frames',
    'frame-finish:painted': 'Painted Bed Frames',
    'frame-finish:rattan': 'Rattan Bed Frames',
    'frame-finish:faux-leather/size:single': 'Single Faux Leather Bed Frames',
    'frame-finish:upholstered/size:single': 'Single Upholstered and Fabric Bed Frames',
    'frame-finish:velvet/size:single': 'Single Velvet Bed Frames',
    'frame-finish:wooden/size:single': 'Single Wooden Bed Frames',
    'frame-finish:faux-leather/size:small-double': 'Small Double Faux Leather Bed Frames',
    'frame-finish:upholstered/size:small-double': 'Small Double Upholstered and Fabric Bed Frames',
    'frame-finish:velvet/size:small-double': 'Small Double Velvet Bed Frames',
    'frame-finish:wooden/size:small-double': 'Small Double Wooden Bed Frames',
    'frame-finish:upholstered': 'Upholstered and Fabric Bed Frames',
    'frame-finish:velvet': 'Velvet Bed Frames'
  },
  29868: {
    'type:stacking': 'Stackable Beds',
    'type:trundle': 'Trundle Beds',
    'type:trundle-with-mattress': 'Trundle Beds with Mattress'
  },
  29870: {
    'type:memory-foam': 'Memory foam Mattresses',
    'type:orthopaedic': 'Orthopaedic Mattresses',
    'mattress-firmness:firm': 'Firm Mattresses',
    'mattress-firmness:medium-soft': 'Medium Soft Mattresses',
    'mattress-firmness:soft': 'Soft Mattresses',
    'type:hybrid': 'Hybrid Mattresses',
    'type:pocket-sprung': 'Pocket sprung Mattresses',
    'size:double/type:hybrid': 'Double Hybrid Mattresses',
    'size:double/type:memory-foam': 'Double Memory Foam Mattresses',
    'size:double/type:open-coil': 'Double Open Coil Mattresses',
    'size:double/type:pocket-sprung': 'Double Pocket Sprung Mattresses',
    'mattress-firmness:extra-firm': 'Extra Firm Mattresses',
    'mattress-firmness:firm/size:double': 'Firm Double Mattresses',
    'mattress-firmness:firm/size:single': 'Firm Single Mattresses',
    'type:gel': 'Gel Mattresses',
    'size:king-size/type:memory-foam': 'King Size Memory Foam Mattresses',
    'size:king-size/type:pocket-sprung': 'King Size Pocket Sprung Mattresses',
    'mattress-firmness:medium-firm/size:double': 'Medium Firm Double Mattresses',
    'mattress-firmness:medium-firm/size:king-size': 'Medium Firm King Size Mattresses',
    'mattress-firmness:medium-firm': 'Medium Firm Mattresses',
    'mattress-firmness:medium-firm/type:pocket-sprung': 'Medium Firm Pocket Sprung Mattresses',
    'mattress-firmness:medium-firm/size:single': 'Medium Firm Single Mattresses',
    'mattress-firmness:medium': 'Medium Mattresses',
    'mattress-firmness:medium-soft/size:single': 'Medium Soft Single Mattresses',
    'type:open-coil': 'Open Coil Mattresses',
    'collection:eco-comfort-breathe': 'S',
    'brands:sealy/type:memory-foam': 'Sealy Memory Foam Mattresses',
    'brands:silentnight/type:memory-foam': 'Silentnight Memory Foam Mattresses',
    'brands:silentnight/type:pocket-sprung': 'Silentnight Pocket Sprung Mattresses',
    'size:single/type:memory-foam': 'Single Memory Foam Mattresses',
    'size:single/type:open-coil': 'Single Open Coil Mattresses',
    'size:single/type:pocket-sprung': 'Single Pocket Sprung Mattresses',
    'size:small-double/type:memory-foam': 'Small Double Memory Foam Mattresses',
    'size:small-double/type:open-coil': 'Small Double Open Coil Mattresses',
    'size:small-double/type:pocket-sprung': 'Small Double Pocket Sprung Mattresses',
    'mattress-firmness:soft/size:double': 'Soft Double Mattresses',
    'size:super-king/type:memory-foam': 'Super King Memory Foam Mattresses',
    'size:toddler': 'Toddler Bed Mattresses'
  },
  29873: {
    'type:bunk-beds': 'Bunk beds',
    'type:cabin-beds': 'Cabin beds',
    'type:toddler-beds': 'Toddler beds',
    'type:mid-sleeper': 'Mid sleeper Kids beds',
    'type:high-sleeper': 'Kids High Sleeper Beds',
    'storage:yes': 'Kids Storage beds',
    'mattress:included/type:bunk-beds': 'Bunk Beds with Mattress Included',
    'desk:yes': 'Kids Beds with Desks',
    'mattress:included': 'Kids Beds with Mattress Included',
    'frame-finish:metal': 'Metal Kids Beds',
    'size:shorty/type:high-sleeper': 'Shorty High Sleeper Kids Beds',
    'mattress:included/size:single': 'Single Beds with Mattress Included',
    'size:single/type:cabin-beds': 'Single Cabin Beds',
    'frame-finish:upholstered': 'Upholstered Kids Beds',
    'frame-finish:wooden': 'Wooden Kids Beds'
  },
  29881: {
    'colour-group:whites': 'Kids White Bedroom Furniture Sets',
    'collection:mia': 'Mia Kids Bedroom Furniture Sets'
  },
  29883: {
    'assembly:fully-assembled': 'Ready Assembled Sideboards',
    'collection:amelie': 'Amelie Sideboards',
    'collection:canyon': 'Canyon Sideboards',
    'collection:cubes': 'Cubes Sideboards',
    'collection:jenson': 'Jenson Sideboards',
    'collection:kent': 'Kent Sideboards',
    'collection:winchester': 'Winchester Sideboards',
    'depth-(cm):40': '40cm Deep Sideboards',
    'width-(cm):120': '120cm Wide Sideboards | Argos',
    'width-(cm):90': '90cm Wide Sideboards | Argos'
  },
  29885: {
    'collection:corners': 'Corner TV Stands',
    'assembly:fully-assembled': 'Ready Assembled TV Units',
    'tv-size-suitability:up-to-32-inch': 'Up to 32 Inch TV Stands',
    'tv-size-suitability:up-to-40-inch': 'Up to 40 Inch TV Stands',
    'tv-size-suitability:up-to-42-inch': 'Up to 42 Inch TV Stands',
    'tv-size-suitability:up-to-43-inch': 'Up to 43 Inch TV Stands',
    'tv-size-suitability:up-to-47-inch': 'Up to 47 Inch TV Stands',
    'tv-size-suitability:up-to-50-inch': 'Up to 50 Inch TV Stands',
    'tv-size-suitability:up-to-55-inch': 'Up to 55 Inch TV Stands',
    'tv-size-suitability:up-to-60-inch': 'Up to 60 Inch TV Stands',
    'tv-size-suitability:up-to-65-inch': 'Up to 65 Inch TV Stands',
    'tv-size-suitability:up-to-70-inch': 'Up to 70 Inch TV Stands',
    'tv-size-suitability:up-to-75-inch': 'Up to 75 Inch TV Stands',
    'brands:habitat/collection:max': 'Habitat Max TV Units and Stands',
    'collection:amersham': 'Amersham TV Units and Stands',
    'collection:boston': 'Boston TV Units and Stands',
    'collection:cubes': 'Cube TV Units and Stands',
    'collection:kent': 'Kent TV Units and Stands',
    'collection:lancaster': 'Lancaster TV Units and Stands',
    'collection:turin': 'Turin TV Units and Stands',
    'collection:winchester': 'Winchester TV Units and Stands',
    'type:corner-tv-units': 'Corner TV Units and Stands'
  },
  29886: {
    'assembly:fully-assembled': 'Fully Assembled Display Cabinets'
  },
  29887: {
    'collection:lift-up': 'Lift Up Coffee Tables',
    'assembly:fully-assembled': 'Ready Assembled Coffee Tables',
    'coffee-table-shape:oval': 'Oval Coffee Tables',
    'coffee-table-shape:round': 'Round Coffee Tables',
    'collection:kent': 'Kent Coffee tables'
  },
  29890: {
    'assembly:fully-assembled': 'Ready Assembled Bookcases',
    'assembly:self%252Dassembly': 'Self Assembly Bookcases and Shelving Units | Argos'
  },
  29892: {
    'depth-(cm):15': '15cm Deep Wall Mounted and Floating Shelves',
    'width-(cm):40': '40cm Wide Wall Mounted and Floating Shelves',
    'width-(cm):45': '45cm Wide Wall Mounted and Floating Shelves'
  },
  29914: {
    'type:cabinets': 'Hallway Cabinets'
  },
  29915: {
    'type:benches': 'Hallway Storage Benches',
    'type:storage-units': 'Hallway Storage Units',
    'assembly:fully-assembled': 'Ready Assembled Hallway Furniture'
  },
  29924: {
    'brands:peckish': 'Peckish Bird Food'
  },
  29926: {
    'type:diffuser-refill': 'Reed Diffuser Refills'
  },
  29967: {
    'type:cordless-telephones': 'Cordless phones',
    'type:corded-telephones': 'Corded phones'
  },
  29997: {
    'nintendo-switch-compatible:yes': 'Nintendo Switch Pre-order games',
    'pc-compatible:yes': 'PC Pre-order games',
    'ps4-compatible:yes': 'PS4 Pre-order games',
    'ps5-compatible:yes': 'PS5 Pre-order games',
    'xbox-one-compatible:yes': 'Xbox One Pre-order games',
    'xbox-series-x-compatible:yes': 'Xbox Series X Pre-order games'
  },
  30006: {
    'accessory-type:steering-wheels': 'PC Steering wheels'
  },
  30036: {
    'accessory-type:steering-wheels': 'PS4 Steering wheels'
  },
  30048: {
    'type:desktop-towers': 'Desktop towers',
    'type:all%252Din%252Done': 'All-in-one PCs'
  },
  30049: {
    'processor-type:intel-core-i7': 'i7 Laptops',
    'processor-type:intel-core-i5': 'i5 Laptops',
    'type:2%252Din%252D1': '2-in-1 Laptops'
  },
  30054: {
    'type:ethernet': 'Ethernet cables'
  },
  30073: {
    'storage-capacity-(gb):2tb': '2TB External hard drives'
  },
  30086: {
    'type:scientific-calculators': 'Scientific calculators'
  },
  30088: {
    'type:laser-printers': 'Laser printers',
    'type:inkjet-printers': 'Inkjet printers'
  },
  30090: {
    'type:cross-cut-shredders': 'Cross cut shredders'
  },
  30095: {
    'type:label-makers': 'Label makers',
    'type:noticeboards-and-whiteboards': 'Noticeboards and whiteboards'
  },
  30106: {
    'screen-type:oled': 'OLED TVs',
    'screen-type:qled': 'QLED TVs',
    'screen-type:led': 'LED TVs',
    'smart-tv:yes': 'Smart TVs'
  },
  30111: {
    'bracket-type:tilt-and-swivel': 'Tilt and swivel TV wall brackets'
  },
  30113: {
    'aerial-type:indoor-aerials': 'Indoor TV aerials'
  },
  30128: {
    'type:wireless-earbuds': 'Wireless earbuds',
    'type:over%252Dear-headphones': 'Over-ear headphones',
    'type:in%252Dear-headphones': 'In-ear Headphones'
  },
  30134: {
    'type:dab-radios': 'DAB Radios',
    'type:analogue-radios': 'Analogue radios'
  },
  30145: {
    'sim-card-plan:pay-as-you-go': 'Pay as you go SIM cards',
    'sim-card-type:data-sim': 'Data only SIM cards'
  },
  30146: {
    'network-provider:vodafone': 'Vodafone Pay as you go phones'
  },
  30147: {
    'operating-system:android': 'Android phones'
  },
  30151: {
    'compatibility:samsung': 'Samsung phone cases',
    'compatibility:apple': 'Apple Phone cases'
  },
  30154: {
    'capacity-(gb):128': '128GB MicroSD memory cards'
  },
  30158: {
    'ipad-version:air': 'iPad Air',
    'ipad-version:ipad-pro': 'iPad Pro'
  },
  30159: {
    'operating-system:android': 'Android tablets'
  },
  30218: {
    'power-type:rechargeable': 'Rechargeable Batteries',
    'type:aa': 'AA Batteries',
    'type:9v': '9V Batteries',
    'type:aaa': 'AAA Batteries',
    'type:c': 'C Batteries',
    'type:d': 'D Batteries'
  },
  30220: {
    'type:freesat-hd': 'Freesat HD Freeview boxes'
  },
  30275: {
    'model:macbook-air': 'Macbook Air',
    'model:macbook-pro': 'Macbook Pro'
  },
  30294: {
    'accessory-type:steering-wheels': 'Nintendo Switch Steering wheels',
    'accessory-type:charging-and-cables': 'Nintendo Switch chargers'
  },
  30302: {
    '': 'Art and Creative Toys'
  },
  30308: {
    '': 'Teddy Bears and Plush Toys',
    'brands:bluey': 'Bluey Teddy Bears and Plush Toys',
    'brands:care-bears': 'Care Bears Teddy Bears and Plush Toys',
    'brands:fingerlings': 'Fingerlings',
    'brands:furreal': 'FurReal Toys',
    'brands:hey-duggee': 'Hey Duggee Soft Toys',
    'brands:in-the-night-garden': 'In the Night Garden Soft Toys',
    'brands:little-live-pets': 'Little Live Pets',
    'brands:squishmallows': 'Squishmallows',
    'brands:squishville': 'Squishville',
    'brands:teletubbies/type:interactive-soft-toys': 'Teletubbies Soft Toys',
    'brands:vtech': 'VTech Soft Toys',
    'type:interactive-soft-toys': 'Interactive and Talking Soft Toys'
  },
  30314: {
    '': '2 For £30 Toys'
  },
  30329: {
    '': 'Kids Sledges'
  },
  30333: {
    '': 'Kids Roller Skates and Inline Skates',
    'type:quad-skates': 'Quad Skates'
  },
  30334: {
    'type:three-wheeled': '3 wheel Scooters',
    'type:electric': 'Electric Scooters for Kids',
    'type:stunt': 'Stunt Scooters for Kids',
    'type:two-wheeled': 'Two Wheeled Scooters for Kids',
    'folds-for-storage:yes': 'Foldable Kids scooters'
  },
  30335: {
    '': 'Ride On Toys',
    'brands:mercedes': 'Mercedes Benz Ride Ons',
    'brands:scuttlebug': 'Scuttlebug Scooter, Bikes, and Ride Ons',
    'type:playsets': 'Ride On Toy Playsets',
    'type:three-wheeled': '3 Wheeled Ride On Toys'
  },
  30344: {
    'brands:gazillion': 'GAZILLION Bubble Solution'
  },
  30346: {
    '': 'Outdoor Kids Ball Games',
    'brands:swingball': 'Swingball Sets'
  },
  30347: {
    '': 'Kids Basketball Hoop Sets'
  },
  30349: {
    '': 'Kids Football Equipment'
  },
  30352: {
    'width-(cm):132': '4ft Paddling Pools',
    'width-(cm):183': '6ft Paddling Pools',
    'width-(cm):244': '8ft Paddling Pools',
    'width-(cm):279': '9ft Paddling Pools',
    'width-(cm):305': '10ft Paddling Pools',
    'width-(cm):366': '12ft Paddling Pools'
  },
  30353: {
    'brands:air-hawk': 'Air Hawk Pool Pumps',
    'brands:clearwater': 'Clearwater Pool Chemicals',
    'type:air-pump': 'Manual and Electric Paddling Pool Pumps'
  },
  30354: {
    'brands:chad-valley': 'Chad Valley Water Guns',
    'brands:hydroclash': 'HydroClash Water Guns',
    'brands:zuru-bunch-o-balloons': 'ZURU BUNCH O BALLOONS',
    'brands:zuru-x%252Dshot': 'ZURU X-SHOT Water Guns',
    'brands:zuru': 'Zuru Water Guns'
  },
  30356: {
    'brands:chad-valley': 'Chad Valley Sand Tables and Water Tables'
  },
  30362: {
    '': 'Playhouses and Wendy Houses',
    'brands:chad-valley': 'Chad Valley Playhouses and Wendy Houses',
    'brands:plum': 'Plum Playhouses',
    'brands:smoby': 'Smoby Playhouses and Wendy Houses',
    'brands:tp-toys': 'TP Toys Playhouses and Wendy Houses',
    'type:fabric': 'Fabric Playhouses and Activity Centres',
    'type:plastic': 'Plastic Playhouses and Wendy Houses',
    'type:wooden': 'Wooden Playhouses and Wendy Houses'
  },
  30366: {
    'type:outdoor-games': 'Outdoor Ball Pits'
  },
  30367: {
    'brands:paw-patrol': 'PAW Patrol Trampolines',
    'shape:rectangular': 'Rectangular Trampolines',
    'shape:round': 'Round Trampolines',
    'shape:square': 'Square Trampolines',
    'suitability:indoor/type:trampolines': 'Indoor Trampolines for Kids',
    'width-(ft):10': '10ft Trampolines',
    'width-(ft):12': '12ft Trampolines',
    'width-(ft):14': '14ft Trampolines',
    'width-(ft):2': '2ft Trampolines',
    'width-(ft):3': '3ft Trampolines',
    'width-(ft):4': '4ft Trampolines',
    'width-(ft):6': '6ft Trampolines',
    'width-(ft):8': '8ft Trampolines'
  },
  30368: {
    'brands:sportspower': 'Sportspower Trampoline Parts',
    'type:accessory-kits': 'Trampoline Accessory Kits'
  },
  30369: {
    'brands:plum': 'Plum Swing Sets'
  },
  30373: {
    '': 'Action Figures and Kids Playsets',
    'brands:cocomelon': 'CoComelon Figures and Playsets',
    'brands:funko': 'Funko Pop!',
    'brands:heroes-of-goo-jit-zu': 'Heroes of Goo Jit Zu Figures and Toys',
    'brands:imaginext': 'Imaginext Figures',
    'brands:jurassic-world': 'Jurassic World Figures and Playsets',
    'brands:micro-toybox': 'Micro Toybox',
    'brands:ninja-kidz': 'Ninja Kidz Playsets and Figures',
    'brands:paw-patrol': 'PAW Patrol Figures and Playsets',
    'brands:playmobil': 'Playmobil Figures and Playsets',
    'brands:real-littles': 'Real Littles Playsets and Figures',
    'brands:tech-deck': 'Tech Deck Toys',
    'brands:transformers': 'Transformers Figures and Playsets',
    'brands:transformers/character:optimus-prime': 'Optimus Prime Toys',
    'brands:zuru-5-surprise': 'Zuru 5 Surprise Playsets and Figures',
    'brands:zuru-mini-brands': 'Zuru Mini Brands Playsets and Figures',
    'brands:zuru-robo-alive': 'Zuru Robo Alive Playsets and Figures',
    'character:buzz-lightyear': 'Buzz Lightyear Figures and Playsets',
    'character:superman': 'Superman Playsets and Figures'
  },
  30377: {
    'brands:john-adams': 'John Adams Toys',
    'brands:national-geographic': 'National Geographic Toys and Science Kits',
    'brands:spy-x': 'Spy X Toys',
    'type:engineering': 'Engineering Toys',
    'type:geography': 'Geography Toys'
  },
  30379: {
    'character:lego-technic': 'LEGO Technic',
    'character:lego-friends': 'LEGO Friends',
    'character:lego-ninjago': 'LEGO NINJAGO',
    'interest:minifigures': 'LEGO Minifigures',
    'character:lego-speed-champions': 'LEGO Speed Champions',
    'character:lego-city': 'LEGO City',
    'character:lego-minecraft': 'LEGO Minecraft',
    'character:lego-marvel': 'LEGO Marvel',
    'character:lego-jurassic-world': 'LEGO Jurassic World',
    'character:lego-creator': 'LEGO Creator',
    'character:lego-dots': 'LEGO DOTS',
    'character:lego-disney': 'LEGO Disney',
    'character:lego-classic': 'LEGO Classic',
    'character:lego-architecture': 'LEGO Architecture Sets',
    'character:lego-art': 'LEGO ART Sets',
    'character:lego-dc': 'LEGO DC',
    'character:lego-dreamzzz': 'LEGO DREAMZzz',
    'character:lego-duplo': 'LEGO DUPLO',
    'character:lego-icons': 'LEGO Icons Sets',
    'interest:animal': 'LEGO Animal Sets',
    'interest:cars': 'LEGO Cars',
    'interest:dinosaurs': 'LEGO Dinosaur Sets',
    'interest:dolls-house': 'LEGO Dolls House Sets',
    'interest:music': 'LEGO Music Sets',
    'interest:space': 'LEGO Space Sets',
    'interest:superheroes': 'LEGO Superheroes Sets'
  },
  30380: {
    'brands:gravitrax': 'Gravitrax',
    'brands:k%27nex': "K'NEX Toy Sets",
    'brands:lego': 'LEGO Construction Sets',
    'brands:mega-bloks': 'Mega Bloks',
    'brands:mega-pokemon': 'Mega Pokemon Sets',
    'brands:professor-puzzle': 'Professor Puzzle Construction Kits'
  },
  30381: {
    'type:baby-dolls': 'Baby dolls',
    'brands:barbie/character:chelsea': 'Chelsea Barbie Doll',
    'character:ariel': 'Little Mermaid Ariel Dolls',
    'character:belle': 'Belle Dolls',
    'character:cocomelon': 'Cocomelon Dolls',
    'character:mulan': 'Mulan Dolls',
    'character:pocahontas': 'Pocahontas Dolls',
    'type:doll-playsets': 'Doll Playsets',
    'type:fashion-dolls': 'Fashion Dolls',
    'type:figures': 'Doll Figures',
    'type:plush-dolls': 'Plush Dolls'
  },
  30388: {
    'brands:tamagotchi': 'Tamagotchi'
  },
  30390: {
    '': 'Electronic Diaries for Kids',
    'brands:vtech': 'VTech Electronic Diaries'
  },
  30391: {
    '': 'Kids Walkie Talkies'
  },
  30393: {
    '': 'Phonics Toys for Speech and Language Development',
    'brands:leapfrog': 'Leapfrog Speech and Language Development Toys',
    'brands:tonies': 'Tonies Characters'
  },
  30395: {
    'brands:photo-creator': 'Photo Creator',
    'brands:vtech': 'VTech Cameras and Video Cameras'
  },
  30397: {
    '': 'Kids Tablets and Toy Mobile Phones',
    'brands:amazon': 'Amazon Fire Kids Tablets'
  },
  30398: {
    'brands:vtech': 'VTech Kids Laptops'
  },
  30410: {
    '': 'Kids Fancy Dress'
  },
  30411: {
    '': 'Toy Makeup and Hairdressing Sets',
    'brands:baby-born': 'Baby Born Styling Heads',
    'brands:barbie': 'Barbie Makeup Sets',
    'brands:monster': 'Monster High Makeup and Beauty Toys',
    'brands:shimmer-n-sparkle': 'Shimmer N Sparkle Makeup Sets',
    'character:shimmer-n-sparkle-instaglam': 'Shimmer N Sparkle Instaglam'
  },
  30420: {
    'activity:building': 'Building toys'
  },
  30423: {
    'brands:cluedo': 'Cluedo',
    'brands:hasbro-gaming': 'Hasbro Board Games',
    'character:cards-against-humanity': 'Cards Against Humanity',
    'type:classic-board-games': 'Classic Board Games',
    'type:strategy-board-games': 'Strategy Board Games',
    'type:trivia-board-games': 'Quiz Board Games',
    'type:word-board-games': 'Word Board Games'
  },
  30424: {
    'type:3d-puzzles': '3D Puzzles',
    'type:adult-jigsaw-puzzles': 'Adult jigsaw puzzles',
    'brands:disney': 'Disney Jigsaw Puzzles',
    'number-of-pieces:1000': '1000 Piece Jigsaw Puzzles',
    'number-of-pieces:24': '24 Piece Jigsaws and Puzzles',
    'number-of-pieces:400': '400 Piece Jigsaws and Puzzles',
    'number-of-pieces:50': '50 Piece Jigsaws and Puzzles',
    'number-of-pieces:500': '500 Piece Jigsaws and Puzzles',
    'type:activity-games': 'Activity Games',
    'type:jigsaw-storage': 'Jigsaw Puzzle Storage',
    'type:kids-jigsaw-puzzles': 'Kids Jigsaw Puzzles'
  },
  30425: {
    '': 'Card Games and Trading Cards',
    'brands:cards-against-humanity': 'Cards Against Humanity',
    'brands:dobble': 'Dobble Card Games',
    'brands:exploding-kittens': 'Exploding Kittens Card Games',
    'brands:panini': 'Panini Trading Cards',
    'brands:pokemon': 'Pokémon Cards',
    'brands:top-trumps': 'Top Trumps',
    'brands:uno': 'UNO Card Games',
    'character:pokemon': 'Pokémon Cards'
  },
  30426: {
    '': 'Remote Control Cars and Other Vehicles',
    'brands:barbie': 'Barbie Remote Control Cars',
    'brands:cmj-rc-cars': 'CMJ RC Cars',
    'car-brand:lamborghini': 'Remote Control Lamborghinis',
    'type:sports-cars': 'Sports Car Remote Control Vehicles'
  },
  30428: {
    'type:trucks': 'Toy trucks',
    'brands:hot-wheels/type:playsets': 'Hot Wheels Playsets',
    'brands:monster-jam': 'Monster Jam Toy Trucks',
    'brands:scalextric': 'Scalextric Sets'
  },
  30429: {
    '': 'Toy Train Sets'
  },
  30448: {
    'brands:vtech': 'VTech Interactive Learning Toys'
  },
  30463: {
    '': '2 For £20 Toys'
  },
  30482: {
    'type:electric-bikes': 'Electric bikes',
    'type:road-bikes': 'Road bikes',
    'type:hybrid-bikes': 'Hybrid bikes',
    'type:folding-bikes': 'Folding bikes',
    'type:mountain-bikes': 'Mountain bikes'
  },
  30485: {
    'type:balance-bikes': 'Balance bikes'
  },
  30505: {
    'person:4': '4 Person Tents'
  },
  30511: {
    'type:cool-bags': 'Cool bags'
  },
  30512: {
    'type:food-flasks': 'Food flasks',
    'type:stainless-steel-flasks': 'Stainless steel flasks'
  },
  30570: {
    'type:floats%2C-kickboards-and-arm-bands': 'Floats, kickboards and arm bands',
    'type:snorkelling%2C-goggles-and-fins': 'Swimming goggles and snorkelling',
    'type:swim-seats%2C-jackets-and-float-suits': 'Swim seats and jackets'
  },
  30572: {
    'ball-size:5': 'Size 5 Footballs',
    'ball-size:0': 'Size 0 Footballs',
    'ball-size:4': 'Size 4 Footballs',
    'ball-size:3': 'Size 3 Footballs',
    'ball-size:2': 'Size 2 Footballs'
  },
  30612: {
    'type:folding-treadmill': 'Folding treadmills'
  },
  30617: {
    'type:knee': 'Knee supports'
  },
  30626: {
    'type:push-up-and-pull-up-bars': 'Push up and pull up bars'
  },
  30630: {
    'type:weight-sets': 'Weight sets'
  },
  30675: {
    'type:notebooks': 'Notebooks'
  },
  42636: {
    'brands:designabear': 'DesignaBear Clothes and Accessories',
    'brands:designafriend/type:doll-clothes-and-accessories': 'DesignaFriend Clothes',
    'character:baby-carrier': 'Baby Doll Carriers',
    'character:barbie/type:doll-cars-and-vehicles': 'Barbie Cars and Other Vehicles',
    'type:doll-baby-walkers': 'Doll Baby Walkers',
    'type:doll-bathroom-furniture': 'Doll Baths and Bathroom Furniture',
    'type:doll-car-seats-and-carriers': 'Doll Car Seats',
    'type:doll-cars-and-vehicles': 'Doll Cars and Vehicles',
    'type:doll-changing-and-feeding': 'Doll Changing and Feeding Accessories',
    'type:doll-clothes-and-accessories': 'Dolls Clothes & Accessories',
    'type:doll-cots-and-beds': 'Doll Cots and Beds',
    'type:doll-highchairs': 'Doll Highchairs',
    'type:doll-wardrobes': 'Doll Wardrobes'
  },
  42640: {
    'brands:blo-pens': 'Blo Pens',
    'brands:chad-valley': 'Chad Valley Art Drawing Sets',
    'brands:crayola': 'Crayola Sets',
    'brands:paw-patrol': 'PAW Patrol Art Sets',
    'brands:peppa-pig': 'Peppa Pig Art Sets',
    'brands:pokemon': 'Pokemon Art Sets',
    'type:aqua-drawing-and-mechanical-drawing': 'Aqua Drawing Tools'
  },
  42641: {
    'brands:cra%252Dz%252Dslimy': 'Cra-Z-Slimy',
    'brands:kinetic-sand': 'Kinetic Sand',
    'brands:play%252Ddoh': 'Play-Doh Sets',
    'brands:so-slime': 'So Slime DIY and Sensations Kits',
    'type:slime': 'Slime Kits'
  },
  42642: {
    '': 'Jewellery Making Kits and Fashion Toys',
    'brands:lego': 'LEGO Jewellery Boxes'
  },
  42643: {
    'brands:barbie': 'Barbie Arts and Crafts Kits',
    'brands:chad-valley': 'Chad Valley Art Sets',
    'brands:lite-brite': 'Lite Brite Toys',
    'brands:mr-frosty': 'Mr Frosty Sets',
    'brands:oonies': 'OONIES',
    'brands:pokemon': 'Pokemon Craft Kits',
    'brands:shrinky-dinks': 'Shrinky Dinks',
    'brands:so-slime': 'So Slime Kits',
    'brands:style-4-ever': 'Style 4 Ever',
    'type:craft-kits': 'Kids Craft Kits'
  },
  62266: {
    'material:bamboo': 'Bamboo Shower Caddies and Storage',
    'colour-group:blacks': 'Black Shower Caddies',
    'material:chrome': 'Chrome Shower Caddies and Storage',
    'brands:croydex': 'Croydex Shower Caddies and Storage',
    'brands:joseph-joseph': 'Joseph Joseph Shower Caddies and Storage',
    'material:metal': 'Metal Shower Caddies and Storage',
    'type:storage-baskets': 'Shower Baskets'
  },
  658435: {
    'type:children%27s-backpacks': "Children's backpacks"
  },
  691380: {
    'capacity-(l):3': '3 Litre Bathroom Pedal Bins',
    'capacity-(l):5': '5 Litre Bathroom Pedal Bins'
  },
  783787: {
    'brands:petface': 'Petface Dog Coats'
  },
  788302: {
    'brands:aeropress': 'AeroPress Coffee Makers'
  },
  789407: {
    'bulb-type:led': 'LED Bathroom Lights'
  },
  789413: {
    'type:stake-lights': 'Outdoor Solar Stake Lights',
    'type:string-lights': 'Outdoor Solar String Lights',
    'type:outdoor-wall': 'Outdoor Solar Wall Lights',
    'type:garden-lamp-post': 'Solar Garden Lamp Post Lights',
    'type:hanging-lanterns': 'Solar Hanging Lanterns'
  },
  789414: {
    'power-supply:battery': 'Battery Powered Outdoor Wall Lights',
    'power-supply:mains': 'Mains Powered Outdoor Wall Lights'
  },
  789422: {
    'type:heated': 'Heated clothes airers',
    'type:3-tier': '3 Tier Clothes Airers',
    'type:balcony': 'Balcony Clothes Airers',
    'type:tower': 'Tower Clothes Airers',
    'type:winged': 'Winged Clothes Airers'
  },
  797720: {
    'tables-in-set:2': 'Set of 2 Nest of Tables',
    'tables-in-set:3': 'Set of 3 Nest of Tables'
  },
  797721: {
    'assembly:fully-assembled': 'Fully Assembled Side Tables'
  },
  798520: {
    'alexa-compatible:yes': 'Alexa Light bulbs'
  },
  798665: {
    'total-weight-(kg):10': '10kg Kettlebells',
    'total-weight-(kg):4': '4kg Kettlebells',
    'total-weight-(kg):8': '8kg Kettlebells',
    'total-weight-(kg):12': '12kg Kettlebells',
    'total-weight-(kg):16': '16kg Kettlebells',
    'total-weight-(kg):2': '2kg Kettlebells',
    'total-weight-(kg):20': '20kg Kettlebells',
    'total-weight-(kg):24': '24kg Kettlebells',
    'total-weight-(kg):6': '6kg Kettlebells'
  },
  810118: {
    '': 'Large outdoor play equipment'
  },
  812660: {
    'illuminated:yes': 'Illuminated Bathroom mirrors'
  },
  815820: {
    '': 'Magic Sets and Prank Toys'
  },
  823758: {
    'storage-options:side-lift': 'Side lift Ottoman beds',
    'storage-options:end-lift': 'End Lift Ottoman and Storage Beds',
    'collection:middleton': 'Middleton Ottoman and Storage Beds',
    'storage-options:4-storage-drawers': 'Ottoman and Storage Beds with 4 Drawers'
  },
  826713: {
    'type:eyelet': 'Kids Eyelet Curtains',
    'type:roller-blinds': 'Kids Roller Blinds'
  },
  1000174: {
    'brands:habitat': 'Habitat Hallway Runners',
    'backing:non%252Dslip': 'Non-slip Hallway Runners'
  },
  1000177: {
    'shape:rectangular': 'Rectangular Mirrors'
  },
  1000178: {
    'shape:decorative': 'Decorative Wall Mirrors',
    'frame-material:glass': 'Glass Wall Mirrors',
    'shape:round': 'Round Wall Mirrors',
    'shape:square': 'Square Wall Mirrors'
  },
  1000232: {
    '': 'Toys £10 and Under',
    'brands:lego': 'LEGO Sets Under £10'
  },
  1028073: {
    '': '2 For £15 Toys',
    'brands:lego': '2 for £15 LEGO Sets'
  }
}

export default refinedHeadingOverrides
